import React from 'react';
import { SalesLanding } from './pages/SalesLanding';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel('1252242806993118');
  return <SalesLanding data-id="element-0" />;
}